<!--我的页面-->
<template>
	<div class="id">
		<div class="navBar" @click="$router.back()">
			<van-icon name="arrow-left" />
			{{ $t('实名认证') }}
		</div>
		<div class="title">{{ $t('真实姓名') }}</div>
		<div class="universal">
			<van-field v-model="nameId" :placeholder="$t('请输入真实姓名')" :border="false" />
		</div>
		<div class="title">{{ $t('选择国籍') }}</div>
		<div class="currency" @click="nationPicker = true">
			<div>{{ currency.text || $t('请选择国籍') }}</div>
			<van-icon name="arrow-down" />
		</div>
		<div class="title">{{ $t('证件类型') }}</div>
		<div class="currency" @click="showPicker = true">
			<div>{{ currencyS.text || $t('请选择证件类型') }}</div>
			<van-icon name="arrow-down" />
		</div>
		<div class="title">{{ $t('证件号码') }}</div>
		<div class="universal">
			<van-field v-model="iDNumber" :placeholder="$t('请输入证件号码')" :border="false" />
		</div>
		<div class="title">{{ $t('请上传证件正面') }}</div>
		<van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" :preview-size="140"
			style="margin-top: 20px;" />
		<div class="title">{{ $t('请上传证件反面') }}</div>
		<van-uploader v-model="fileListA" :max-count="1" :after-read="afterReadA" :preview-size="140"
			style="margin-top: 20px;" />
		<van-button class="btn" type="primary" @click="submit" :disabled="isSubmitDisabled" :loading="isUploading">
			{{ advancedStatus == 0 ? $t('待审核') : advancedStatus == 1 ? $t('已认证') : advancedStatus == 2 ? $t('审核失败') :
                $t('提交') }}
		</van-button>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @confirm="onConfirmS" @cancel="showPicker = false"
				:confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')" />
		</van-popup>

		<van-popup v-model="nationPicker" position="bottom">
			<div class="gjc">
				<van-field v-model="searchText" :placeholder="$t('国家搜索')" clearable @input="onSearch"
					input-align="center" />
				<van-picker title="" show-toolbar :columns="filteredColumns" @confirm="onConfirm"
					@cancel="nationPicker = false" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')" />
			</div>
		</van-popup>
	</div>
</template>
<script>
	import {
		get,
		post
	} from '@/http/request'
	import apis from '@/http/api'
	import {
		mapState
	} from "vuex";
	export default {
		components: {

		},
		data() {
			return {
				iDNumber: '',
				nameId: '',
				nation: '',
				currency: {},
				currencyS: {},
				// columns: [],
				columnsT: [], //国家
				fileList: [], // 存放上传的图片
				fileListA: [], // 存放上传的图片
				showPicker: false,
				nationPicker: false,
				searchText: '', // 搜索关键词
				filteredColumns: [], // 过滤后的选项
				review: true,
				advancedStatus: '',
				isUploading: false,
			};
		},
		created() {
			// 初始展示所有选项
		},
		computed: {
			...mapState(["config"]),
			isSubmitDisabled() {
				const isImageMissing = this.fileList.length === 0 || this.fileListA.length === 0;
				const isAlreadySubmitted = this.advancedStatus === 0 || this.advancedStatus === 1;

				return this.isUploading || isImageMissing || isAlreadySubmitted;
			},
			// columns(){
			// 	return this.config.identityType.map(item => ({
			//           text: item.value,
			//           id: item.key
			//       }));
			// }
		},

		mounted() {
			get(this.$apis.getConfig).then(res => {
				if (res.code != 1) return
				this.columns = res.data.identityType.map(item => ({
					text: item.value,
					id: item.key
				}));
			})

			this.getCountryList()
		},

		methods: {
			onSearch() {
				// 根据搜索框内容过滤选项
				const keyword = this.searchText.trim();
				console.log(keyword);
				if (!keyword) {
					this.filteredColumns = this.columnsT;
				} else {
					this.filteredColumns = this.columnsT.filter(item => item.text.includes(keyword));
				}
			},

			async afterRead(file) {
				// 这里写上传逻辑，比如调接口
				const formData = new FormData();
				this.isUploading = true;
				formData.append("file", file.file);
				// 模拟上传成功后，替换成服务器返回的 URL
				const res = await post(apis.upload, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				this.isUploading = false;
				if (res.code == 1) {
					this.fileList = [{
						url: res.data.fullurl
					}];
					return
				}
			},
			async afterReadA(file) {
				// 这里写上传逻辑，比如调接口
				const formData = new FormData();
				this.isUploading = true;
				formData.append("file", file.file);
				// 模拟上传成功后，替换成服务器返回的 URL
				const res = await post(apis.upload, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				this.isUploading = false;
				if (res.code == 1) {
					this.fileListA = [{
						url: res.data.fullurl
					}];
					return
				}
			},
			onConfirm(value) {
				this.currency = value
				this.nationPicker = false
				this.searchText = ''
				this.filteredColumns = this.columnsT
			},

			onConfirmS(value) {
				this.currencyS = value
				this.showPicker = false

			},


			//充值提交
			async submit() {
				if (this.advancedStatus == 0 || this.advancedStatus == 1) {
					return
				}
				if (this.fileList.length == 0) {
					this.$toast(this.$t('请上传证件正面'))
					return
				}
				if (this.fileListA.length == 0) {
					this.$toast(this.$t('请上传证件反面'))
					return
				}
				if (this.isSubmitDisabled) return;
				const res = await post(apis.mobileReal, {
					front: this.fileList[0].url,
					back: this.fileListA[0].url,
					type: this.currencyS.id,
					country_id: this.currency.id,
					name: this.nameId,
					id_number: this.iDNumber
				})
				if (res.code == 1) {
					// this.fileList = []
					this.$toast(res.msg);
					this.review = false
					return
				}
			},
			//国家
			async getCountryList() {
				const res = await get(apis.getCountryList)
				if (res.code == 1) {
					this.columnsT = res.data.map(item => ({
						text: item.name,
						id: item.id
					}));
					this.filteredColumns = this.columnsT;
					this.getUserRealInfo()
					return
				}
			},
			async getUserRealInfo() {
				const res = await get(apis.getUserRealInfo)
				if (res.code == 1) {
					console.log(res.data, res.data.advanced_status, 'shenhexinxi ');
					this.advancedStatus = res.data.advanced_status
					if (res.data.advanced_status != 3) {
						this.fileList.push({
							url: res.data.front
						})
						this.fileListA.push({
							url: res.data.back
						})
						this.currencyS = this.columns.filter(item => item.id == res.data.type)[0]
						this.currency = this.columnsT.filter(item => item.id == res.data.country_id)[0]
						this.nameId = res.data.name
						this.iDNumber = res.data.id_number
						return
					}
					return
				}
			},

		},
	};
</script>
<style lang="less" scoped>
	::v-deep .van-cell {
		padding: 0;
	}

	::v-deep .van-uploader__upload {
		background-color: #1b1b2e !important;
	}

	.gjc {
		::v-deep .van-cell {
			padding: 10px;
		}

		::v-deep .van-cell::after {
			border-bottom: none;
		}
	}

	.id {
		color: #fff;
		padding: 0 15px;
		padding-bottom: 20px;
		padding-top: 50px;
		font-size: 14px;

		.currency {
			padding: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border: 1px solid #3a3f47;
			margin-top: 10px;
			border-radius: 5px;

			.address {
				width: 85%;
				word-break: break-all;
			}
		}

		.navBar {
			background-color: #090d13;
			padding: 15px 10px;
			font-size: 18px;
			font-weight: 700;
			border-radius: 4px;
		}

		.title {
			padding-top: 20px;
			font-size: 16px;
			font-weight: 700;
		}

		.table {
			background: #000;
			color: #fff;
			margin-top: 20px;
			font-size: 12px;

			.header {
				background: #1c222c;
				padding: 10px 0;
				border-radius: 5px;

				.vanItem {
					text-align: center;
				}
			}

			.scroll {
				overflow-y: auto;
				height: 45vh;
				scrollbar-width: none;
				/* Firefox */
				-ms-overflow-style: none;
				/* IE/Edge */
			}

			.row {
				border-bottom: 1px solid #222b39;
				padding: 10px 0px;
				display: flex;
				align-items: center;
				font-size: 11px;

				.trade {
					text-align: center;
				}
			}
		}


		.universal {
			padding: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border: 1px solid #3a3f47;
			margin-top: 10px;
			border-radius: 5px;

			.address {
				width: 85%;
				word-break: break-all;
			}
		}

		.btn {
			width: 100%;
			margin: 20px 0;
			background-color: #07ecfe;
			border-radius: 5px;
			color: #000;
		}



	}
</style>